// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_7s-3";
export var contentContainer = "_7s-0";
export var editorContainer = "_7s-1";
export var quillInputForm = "_7s-2";
export var zoneDivider = "_7s-4";